import React from 'react';
import { StepProgressBarContainer, StepsContainer, StepContainer, Step, ArrowIcon } from './styles';

export default React.memo(({ levelsData, currentLevel, setCurrentLevel, language, inputExercise }) => {
  const getCompletionInfo = (level) => inputExercise?.levelData?.[level]?.[language]?.flowProgress?.length ?? 0;

  return (
    <StepProgressBarContainer>
      <ArrowIcon
        className="fa fa-chevron-left"
        disabled={currentLevel === 0}
        onClick={() => {
          if (currentLevel === 0) return;
          setCurrentLevel(currentLevel - 1);
        }}
      />
      <StepsContainer>
        {Object.keys(levelsData).map((_, index) => (
          <StepContainer key={`step${index}`}>
            <Step
              value={getCompletionInfo(index)}
              max={levelsData[index]?.length}
              isActive={index === currentLevel}
              isIncomplete={index > currentLevel}
              onClick={() => {
                if (index !== currentLevel) setCurrentLevel(index);
              }}
            />
          </StepContainer>
        ))}
      </StepsContainer>
      <ArrowIcon
        className="fa fa-chevron-right"
        disabled={currentLevel === Object.keys(levelsData).length - 1}
        onClick={() => {
          if (currentLevel === Object.keys(levelsData).length - 1) return;
          setCurrentLevel(currentLevel + 1);
        }}
      />
    </StepProgressBarContainer>
  );
});
